import { Header } from "../../header/Header";
import { Footer } from "../footer/Footer";
import { Joinus } from "../joinus/Joinus";
import a1 from "../../assets/a1.jpg";
import { ServicesShowcaseCouple } from "../service/ServicesShowcaseCouple";

export const Couple = () => {
  return (
    <div>
      <Header />

      <section className="relative overflow-hidden bg-gradient-to-br from-brand-900 via-brand-800 to-sea-800 py-20 sm:py-24">
        <div className="pointer-events-none absolute -left-20 top-0 h-64 w-64 rounded-full bg-white/10 blur-3xl" />
        <div className="pointer-events-none absolute -right-20 bottom-0 h-64 w-64 rounded-full bg-sea-400/20 blur-3xl" />
        <div className="relative mx-auto max-w-4xl px-4 text-center sm:px-6">
          <span className="text-xs font-bold uppercase tracking-[0.3em] text-brand-200">
            Our Services
          </span>
          <h1 className="mt-4 font-display text-5xl font-semibold text-white sm:text-6xl">
            Couple Therapy
          </h1>
        </div>
      </section>

      <section className="bg-white py-20 sm:py-24">
        <div className="mx-auto grid max-w-7xl items-center gap-12 px-4 sm:px-6 lg:grid-cols-2 lg:gap-16 lg:px-8">
          <div className="relative mx-auto w-full max-w-lg">
            <div className="absolute inset-0 -rotate-2 rounded-[2rem] bg-brand-100" />
            <img
              src={a1}
              alt="Couple therapy session"
              className="relative w-full rounded-[2rem] object-cover shadow-soft"
            />
          </div>
          <div>
            <h2 className="font-display text-3xl font-semibold text-slate-900 sm:text-4xl">
              Grow closer, communicate better
            </h2>
            <p className="mt-6 text-lg leading-relaxed text-slate-600">
              A lot of times couples do not get along and experience
              difficulties in their relationship. Couples or relationship
              therapy is designed for partners or two people involved with
              each other romantically. It focuses towards improvement of
              communication, resolves conflict and enhances the overall
              quality of the relationship. this therapy may also be helpful
              for couples who are dating or individuals who are planning to
              get married. It also stands with a goal of developing healthy
              pattern of interaction and strengthens their emotional
              connection. This therapy works well through specific issues that
              may be causing distress in a relationship.
            </p>
          </div>
        </div>
      </section>

      <ServicesShowcaseCouple />
      <Joinus />
      <Footer />
    </div>
  );
};
